import React, { useState } from "react";
import { ChromePicker } from "react-color";

function ColorPicker({ color, onChange }) {
  const [isColorPickerVisible, setIsColorPickerVisible] = useState(false);

  const toggleColorPicker = () => {
    setIsColorPickerVisible(!isColorPickerVisible);
  };

  return (
    <div>
      {/* Цветной блок */}
      <span
        style={{
          display: "inline-block",
          marginLeft: "10px",
          width: "20px",
          height: "20px",
          backgroundColor: color,
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
        onClick={toggleColorPicker}
      ></span>

      {/* Палитра цветов */}
      {isColorPickerVisible && (
        <div style={{ position: "relative", zIndex: 2 }}>
          <ChromePicker color={color} onChange={onChange} />
          <button
            style={{
              marginTop: "10px",
              padding: "5px 10px",
              border: "none",
              backgroundColor: "gray",
              color: "white",
              cursor: "pointer",
            }}
            onClick={toggleColorPicker}
          >
            Закрыть
          </button>
        </div>
      )}
    </div>
  );
}

export default ColorPicker;
